import {useRef, useState} from 'react';
import Modal from '../../components/modal_dialog';
import FormAsyncSelect from '../../components/form-async-select';
import {fetch} from '../../utils/api-wrapper';

// XPEN-3838: hand a pending line to another approver from the line approval window.
export default function DelegateLineApprovalModal({data, url, onClose, onSuccess}) {
    const [approver, setApprover] = useState(null);
    const [sending, setSending] = useState(false);
    const [error, setError] = useState(null);
    const inFlight = useRef(false);
    const t = (key) => data.t.read(key);
    const submit = () => {
        if (!approver?.value || inFlight.current) return false;
        inFlight.current = true;
        setSending(true);
        setError(null);
        fetch(url, 'POST', {approver_id: approver.value}, () => {
            inFlight.current = false;
            setSending(false);
            onSuccess(approver.label);
        }, response => {
            inFlight.current = false;
            setSending(false);
            const status = response?.response?.status;
            const code = response?.response?.data?.msg;
            setError(t(code === 'invalid_approver' ? 'approval_modal.another_request_invalid_approver'
                : [401, 409].includes(status) ? 'approval_modal.delegate_stale' : 'approval_modal.delegate_error'));
        });
        // The modal's loading state follows the request, including failed retries.
        return false;
    };
    return <Modal
        title={t('approval_modal.delegate_title')}
        okText={t('delegate')}
        okAction={submit}
        invalid={!approver?.value || sending}
        noProcessingLoading
        okLoading={sending}
        closeDisabled={sending}
        zIndex={1050}
        cancelText={t('cancel')}
        cancelAction={() => { if (!inFlight.current) onClose(); }}
        disableBackdropClose={sending}
    >
        <p className="text-muted">{t('approval_modal.delegate_explanation')}</p>
        <label htmlFor="delegate-approver">{t('approver')}</label>
        <FormAsyncSelect
            data={data}
            inputId="delegate-approver"
            name="delegate-approver"
            searchUrl="/client/users/approvers/search"
            placeholder={t('approver')}
            value={approver}
            isDisabled={sending}
            isClearable
            stylesOverride={{control: base => ({...base, border: '1px solid #ced4da', borderRadius: 4})}}
            optionMap={user => user ? {
                value: user.id_user ?? user.value,
                label: user.label || [user.first_name, user.last_name].filter(Boolean).join(' ') || user.username,
            } : null}
            onChange={setApprover}
        />
        {error && <div role="alert" className="alert alert-danger mt-3">{error}</div>}
    </Modal>;
}
